export const getUserAndEventTime = () => {
    return {
        eventTime: new Date().toISOString(),
        user: {
            _id: '602c4d53dc89c40008db562a',
            identifier: 'YOUR_UNIQUE_IDENTIFIER',
            connected: true
        }
    };
};
//# sourceMappingURL=get-user-and-event-time.js.map